import { InspirationTopic } from "Model/Inspiration";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchInspirationTopicsAsync } from "Util/firebaseHelper";

export interface InspirationState {
  topics: InspirationTopic[];
  loading: boolean;
  error: string | null;
}

const initialState: InspirationState = {
  topics: [],
  loading: false,
  error: null,
};

// Async thunk to fetch topics from Firebase
export const fetchInspirationTopics = createAsyncThunk(
  "inspirations/fetchInspirationTopics",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchInspirationTopicsAsync();
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const inspirationsSlice = createSlice({
  name: "inspirations",
  initialState,
  reducers: {
    fetchTopicsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchTopicsSuccess(state, action: PayloadAction<InspirationTopic[]>) {
      state.topics = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchTopicsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInspirationTopics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchInspirationTopics.fulfilled,
        (state, action: PayloadAction<InspirationTopic[]>) => {
          state.topics = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
      .addCase(fetchInspirationTopics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { fetchTopicsStart, fetchTopicsSuccess, fetchTopicsFailure } =
  inspirationsSlice.actions;

export default inspirationsSlice.reducer;
